import getLocalString from "constants/Localization";
import { useSyncProjectMapMeasurementsMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useSyncProjectMapMeasurements() {
  const [mutation, { loading, error, data }] = useSyncProjectMapMeasurementsMutation();

  const [customMutation, context] = useBitumioMutation(
    {
      mutation,
      loading,
      error,
      data,
      key: "syncProjectMapMeasurements",
    },
    {
      successMessage: getLocalString("projectMaps.sync-measurements-success"),
      failureMessage: getLocalString("projectMaps.sync-measurements-failure"),
    }
  );

  return [customMutation, context] as const;
}
